module.exports = __webpack_public_path__ + "img/product-7-zhuanye.92e0a8a8.png";